<template>
    <div class='skills-level-edit-modal'>
        <b-modal :active="true" :canCancel="false">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">Rediger studerendes information</p>
                </header>

                <section class="modal-card-body">
                    <div class="columns">
                        <div class="column is-6">
                            <p class="subtitle">Niveau</p>
                            <b-field>
                                <b-select v-model="selectedLevel"
                                          placeholder="Vælg en færdighed"
                                          :loading="!levels.length"
                                          icon="clipboard-text" expanded>
                                    <option v-for="level in levels"
                                            :key="level.id"
                                            :value="level.id">
                                        {{$t('levels.' + level.name + '.name')}}
                                    </option>
                                </b-select>
                            </b-field>
                        </div>
                    </div>

                    <p class="subtitle">Færdigheder</p>
                    <div class="block" v-for="group in groupedSkills" :key="group.id">
                        <p class="label">{{ $t('skills.groups.' + group.name + '.name') }}</p>

                        <b-checkbox v-for="skill in group.skills" :key="skill.id" v-model="selectedSkills"
                                    :native-value="skill.id">
                            {{$t(`skills.${skill.name}.name`)}}
                        </b-checkbox>
                    </div>

                    <p class="notification is-danger" v-if="selectedSkills.length < 1">
                        Der skal mindst vælges én færdighed
                    </p>
                </section>

                <footer class="modal-card-foot content-pulled-right">
                    <button class="button" @click="close" type="button">{{$t('global.actions.back')}}</button>

                    <button class="button is-primary" :class="{'is-loading': isSubmitting}"
                            @click="submit" :disabled="selectedSkills.length < 1">
                        {{$t('global.actions.update')}}
                    </button>
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import StudentService from '@/taskflex/students/services/StudentService';
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                selectedLevel: null,
                selectedSkills: [],
                isSubmitting: false,
            };
        },

        props: {
            student: {
                type: Object,
                required: true,
            },
        },

        computed: {
            ...mapGetters({
                levels: 'levels/levels',
                groupedSkills: 'skills/skillGroups',
            }),
        },

        mounted() {
            this.selectedLevel = this.student.level.id;
            this.selectedSkills = this.student.skills.map(skill => skill.id);

            if (!this.groupedSkills.length) {
                this.$store.dispatch('skills/loadSkillGroups');
            }

            if (!this.levels.length) {
                this.$store.dispatch('levels/loadLevels');
            }
        },

        methods: {
            async submit() {
                if (!await this.$validator.validateAll()) {
                    return;
                }

                const options = {
                    level_id: this.selectedLevel,
                    skills: this.selectedSkills,
                };

                this.isSubmitting = true;

                StudentService.update(this.student.id, options, () => {
                    this.isSubmitting = false;

                    this.$eventHub.$emit('student.detail.reload');
                    this.close();
                });
            },

            close() {
                this.$emit('close');
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/administration/components/students/SkillsLevelEditModal.vue